import React from 'react';
import './Portfolio.css';
import { Link as ScrollLink } from 'react-scroll';

const Portfolio = () => {
  return (
    <section className="portfolio-section" id="portfolio">
      <div className="portfolio-header">
        <h2 className="gradient-title">Portfolio</h2>
        <div className="title-underline"></div>
        <p className="section-description">
          Browse some of the websites and platforms we’ve built for clients across various industries.
        </p>
      </div>

      <div className="coming-soon-card">
        <div className="badge">🚧</div>
        <h3>Showcase coming soon</h3>
        <p>
          We’re curating a selection of recent builds—plugins, apps, and integrations. 
          In the meantime, feel free to reach out or explore our services.
        </p>

        <div className="cta-row">
          <ScrollLink
            to="services"
            smooth
            duration={800}
            className="btn btn-primary"
          >
            Explore Services
          </ScrollLink>

          <a href="mailto:info@genseqsolutions.co.za" className="btn btn-outline">
            Email Us
          </a>
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
